import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {buildTeammateDisplayName} from '../../../../../../../libs/shared/core/src/models/helpers/teammateModelHelpers';
import {getFlatActiveTeammates} from '../../../../../../../libs/shared/core/src/store/data/teammates/commonTeammatesSelectors';
import {TeammateAvatar} from '../../../../../../../libs/shared/ui/src/components/avatar/teammateAvatar';
import {VisualSizesEnum} from '../../../../../../../libs/shared/ui/src/styles/commonStyles';
import {useAppSelector} from '../../../../../../helpers/appReduxHelpers';
import {SearchTeammateDropdownContainer} from '../../../../../common/dropdowns/search/searchTeammateDropdownContainer';
import {MacroInputDropdownBoxCoordinator} from './common/macroInputDropdownBoxCoordinator';
import {MacroInputCommonProps} from './common/macroInputTypes';

/*
 * Props.
 */

interface MacroInputTeammateProps extends MacroInputCommonProps<number> {}

/*
 * Styles.
 */

const StyledValueWrapper = styled.div`
  display: flex;
  align-items: center;

  gap: 8px;
`;

/*
 * Component.
 */

export const MacroInputTeammate: FC<MacroInputTeammateProps> = ({value, onChange, description, label}) => {
  const teammates = useAppSelector(getFlatActiveTeammates);
  const selectedTeammate = teammates.find((teammate) => teammate.id === value);

  return (
    <MacroInputDropdownBoxCoordinator
      value={selectedTeammate}
      renderValue={(teammate) => (
        <StyledValueWrapper>
          <TeammateAvatar teammate={teammate} size={VisualSizesEnum.SMALL} />
          {buildTeammateDisplayName(teammate)}
        </StyledValueWrapper>
      )}
      placeholder={<Trans id="macro-input-teammate-placeholder">Select teammate</Trans>}
      label={label}
      description={description}
      renderDropdown={(popoverProps) => (
        <SearchTeammateDropdownContainer
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...popoverProps}
          headerTitle={<Trans id="macro-input-teammate-dropdown-title">Teammates</Trans>}
          width={260}
          maxHeight={400}
          selectedEmail={selectedTeammate?.email}
          onChange={(teammate) => onChange(teammate.id)}
        />
      )}
    />
  );
};
